import Inputmask from "inputmask";
import { load } from "recaptcha-v3";

let ambassadorForm = args => {
    return {
        limitReached: false,
        testing: false, //<--make true if testing (removes error blocks)
        contextPath: args.contextPath,
        successPageLink: args.successPageLink,
        errorPageLink: args.errorPageLink,
        formElement: document.querySelector(".ambassadorWrap"),
        submitUrl: "/.rest/ambassador/",
        baseEndPtUrl: "",
        //choose multiple queryselectors
        //days of the week
        daysOfTheWeek: [],
        //times of the day
        timesOfTheDay: [],
        //end choose multiple
        timeZone: "",
        //checkboxes
        voicemails: document.querySelector("[name='voicemails']"),
        formData: {
            // Default schema
            patientOrCaregiver: "",
            indication: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            timesOfTheDay: [],
            timeZone: "",
            voicemails: false,
            certify: false,
            confirm: false,
            personalizedContent: false,
            smsConsent: false
        },
        canSubmit() {
            // this is checks to see if the formData has the entire schema required for submission
            if (this.formData.patientOrCaregiver && this.formData.indication && this.formData.firstName && this.formData.lastName && this.formData.email && this.formData.phone && this.formData.timesOfTheDay.length >= 1 && this.formData.timeZone && this.formData.voicemails && this.formData.certify && this.formData.confirm) {
                return true;
            }
            return false;
        },
        env() {
            const winOrigin = window.location.origin;
            this.baseEndPtUrl = this.contextPath ? winOrigin + this.contextPath : (this.baseEndPtUrl = winOrigin);
        },
        init() {
            this.env();
            this.toggleTesting();
            this.ambotLimit();
            Inputmask().mask(document.querySelectorAll("input"));
        },
        ambotLimit() {
            let limits = document.querySelectorAll("[data-limit]");
            limits.forEach((limit, index) => {
                limit.onclick = () => {
                    let max = limit.dataset.limit;
                    let checkbox = limit.querySelectorAll('input[type="checkbox"]:checked');
                    if (max <= checkbox.length) {
                        this.limitReached = true;
                        limits[index].classList.add("limitReached");
                    } else {
                        this.limitReached = false;
                        limits[index].classList.remove("limitReached");
                    }
                    return max < checkbox.length ? false : true;
                };
            });
        },
        toggleTesting() {
            let isTesting = this.formElement.dataset.testing;
            switch (isTesting) {
                case "testing":
                    this.testing = true;
                    break;
                case "not-testing":
                    this.testing = false;
                    break;
            }
        },
        formDataBuildChecked(el) {
            document.querySelectorAll(el).forEach(topic => {
                let topicInput = topic.querySelector("input");
                if (topicInput.checked) {
                    this.formData[topicInput.name] = topicInput.value;
                } else {
                    this.formData[topicInput.name] = "";
                }
            });
        },
        formDataBuildSelected(el) {
            let text = el.innerText;
            let dropdownItems = el.parentElement.querySelectorAll(".dropdown-item");
            dropdownItems.forEach(item => {
                if (text == item.innerText) {
                    this.formData[item.dataset.name] = item.dataset.value;
                }
            });
        },
        submit() {
            if (this.slideValidation()) {
                let body = new URLSearchParams();
                let url = this.baseEndPtUrl + this.submitUrl;
                var recaptchaV3String = $("button[name='recaptcha']").val();
                var recaptchaV3Boolean = recaptchaV3String === "true";

                if (recaptchaV3Boolean) {
                    const recaptchaID = document.querySelector(".submit").dataset.sitekey;
                    load(recaptchaID).then(recaptcha => {
                        recaptcha.execute("submit").then(token => {
                            this.postData(token, recaptchaV3Boolean, body, url);
                        });
                    });
                } else {
                    let token = false;
                    this.postData(token, recaptchaV3Boolean, body, url);
                }
            }
        },
        async postData(token, recaptcha, body, url) {
            this.formDataBuildSelected(this.$refs.timezone);
            //add multiples to payload seperately
            for (const [key, value] of Object.entries(this.formData)) {
                if (Array.isArray(value)) {
                    value.forEach(v => {
                        body.append(key, v);
                    });
                } else {
                    body.append(key, value);
                }
            }
            if (recaptcha) {
                body.append("g-recaptcha-response", token);
            }
            let response;
            try {
                response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: body
                });
            } catch (error) {
                window.location.replace(this.errorPageLink);
            }
            if (response.ok) {
                const res = await response.text();
                window.location.replace(this.successPageLink);
                return JSON.parse(res);
            }
            return false;
        },
        openSelect(e) {
            let inner = e.target.nextElementSibling;
            let target = e.target;

            inner.classList.toggle("hidden");
            inner.classList.toggle("open");

            target.classList.toggle("default");
            target.classList.toggle("open");

            if (e.target.classList.contains("timezone")) {
                this.checkTimezone();
            } else {
                this.checkDupixentUse();
            }
        },
        isRequired(input) {
            if (input.value === "") {
                return false;
            } else {
                return true;
            }
        },
        isEmailValid(email) {
            return String(email.value)
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        },
        isPhoneValid(phone) {
            if (phone.value.length < 10) {
                return false;
            } else {
                return true;
            }
        },
        isValidPhone() {
            if (!this.formData.phone) return false;
            const cleanPhone = this.formData.phone.replace(/\D/g, "");
            return cleanPhone.length === 10;
        },
        isGroupValid(groups) {
            let options = [...groups];

            let isChecked = options.some(option => {
                return option.querySelector("input").checked;
            });
            return isChecked;
        },
        isChecked(input) {
            let trueInput = input.querySelector("input");
            if (trueInput.checked) {
                return true;
            } else {
                return false;
            }
        },
        showSuccess(input) {
            const formField = input.parentElement;
            formField.classList.remove("error");
            formField.classList.add("success");
            const error = formField.querySelector("small");
            error.textContent = "";
        },
        showError(input, message) {
            const formField = input.parentElement;
            formField.classList.add("error");
            formField.classList.remove("success");
            const error = formField.querySelector("small");
            error.textContent = message;
        },
        checkPatientType() {
            let patientType = this.$refs.patientType.querySelectorAll(".radio");
            let valid = false;
            if (this.isGroupValid(patientType)) {
                this.showSuccess(patientType[0]);
                valid = true;
            } else {
                this.showError(patientType[0], "Please select an option above.");
            }

            return valid;
        },
        checkDupixentUse() {
            let dupixentuse = this.$refs.dupixentUse;
            let valid = false;
            if (dupixentuse.classList.contains("selected")) {
                this.showSuccess(dupixentuse);
                valid = true;
            } else {
                this.showError(dupixentuse, "Please select a condition.");
            }

            return valid;
        },
        checkTimezone() {
            let timezone = this.$refs.timezone;
            let valid = false;
            if (timezone.classList.contains("selected")) {
                this.showSuccess(timezone);
                valid = true;
            } else {
                this.showError(timezone, "Please select a time zone.");
            }

            return valid;
        },
        checkFirstName() {
            let firstname = this.$refs.firstName;
            let valid = false;
            if (this.isRequired(firstname)) {
                this.showSuccess(firstname);
                valid = true;
            } else {
                this.showError(firstname, "Please enter a first name.");
            }

            return valid;
        },
        checkLastName() {
            let lastname = this.$refs.lastName;
            let valid = false;
            if (this.isRequired(lastname)) {
                this.showSuccess(lastname);
                valid = true;
            } else {
                this.showError(lastname, "Please enter a last name.");
            }

            return valid;
        },
        checkEmail() {
            let email = this.$refs.email;
            let valid = false;
            if (this.isEmailValid(email)) {
                this.showSuccess(email);
                valid = true;
            } else {
                this.showError(email, "Please enter a valid email.");
            }

            return valid;
        },
        checkPhone() {
            let phone = this.$refs.phone;
            let valid = false;
            if (this.isPhoneValid(phone)) {
                this.showSuccess(phone);
                valid = true;
            } else {
                this.showError(phone, "Please enter a valid phone number.");
            }
            Inputmask({ mask: "999-999-9999", placeholder: "XXX-XXX-XXXX" }).mask(phone);
            return valid;
        },
        checkVoicemail() {
            let voicemail = this.$refs.voicemail;
            let valid = false;
            if (this.isChecked(voicemail)) {
                this.showSuccess(voicemail);
                valid = true;
            } else {
                this.showError(voicemail, "This confirmation is required to submit the form.");
            }

            return valid;
        },
        checkTimes() {
            let time = this.$refs.time.querySelectorAll(".chkLabel");
            let valid = false;
            if (this.isGroupValid(time)) {
                this.showSuccess(time[0]);
                valid = true;
            } else {
                this.showError(time[0], "Please select an option.");
            }
            return valid;
        },
        checkCertify() {
            let certify = this.$refs.certify;
            let valid = false;
            if (this.isChecked(certify)) {
                this.showSuccess(certify);
                valid = true;
            } else {
                this.showError(certify, "This confirmation is required to submit the form.");
            }

            return valid;
        },
        checkConfirm() {
            let confirm = this.$refs.confirm;
            let valid = false;
            if (this.isChecked(confirm)) {
                this.showSuccess(confirm);
                valid = true;
            } else {
                this.showError(confirm, "This confirmation is required to submit the form.");
            }

            this.checkTimezone();

            return valid;
        },
        slideValidation() {
            //check using utilities
            let isPatientTypeValid = this.checkPatientType();
            let isDupixentUseValid = this.checkDupixentUse();
            let isTimeZoneValid = this.checkTimezone();
            let isFirstNameValid = this.checkFirstName();
            let isLastNameValid = this.checkLastName();
            let isEmailValid = this.checkEmail();
            let isPhoneValid = this.checkPhone();
            let isVoicemailValid = this.checkVoicemail();
            let isTimeValid = this.checkTimes();
            let isCertifyValid = this.checkCertify();
            let isConfirmValid = this.checkConfirm();

            let slideValid = isPatientTypeValid && isDupixentUseValid && isFirstNameValid && isLastNameValid && isEmailValid && isPhoneValid && isVoicemailValid && isCertifyValid && isConfirmValid && isTimeValid && isTimeZoneValid;
            //total is valid
            if (!this.testing) {
                return slideValid;
            } else {
                return true;
            }
        }
    };
};

//putting mentorlogic in window
window.ambassadorForm = ambassadorForm;
